import { createContext, useContext, ReactNode, useState } from "react";

interface FilterContextType {
  startDate: string;
  endDate: string;
  company: string;
  appliedStartDate: string;
  appliedEndDate: string;
  appliedCompany: string;
  setStartDate: (value: string) => void;
  setEndDate: (value: string) => void;
  setCompany: (value: string) => void;
  handleFilter: () => void;
  handleReset: () => void;
  hasActiveFilters: boolean;
}

const FilterContextSub = createContext<FilterContextType | undefined>(undefined);

export const FilterSubProvider = ({ children }: { children: ReactNode }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [company, setCompany] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");
  const [appliedCompany, setAppliedCompany] = useState("");

  const handleFilter = () => {
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setAppliedCompany(company);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setCompany("");
    setAppliedStartDate("");
    setAppliedEndDate("");
    setAppliedCompany("");
  };

  const hasActiveFilters = !!(appliedStartDate || appliedEndDate || appliedCompany);

  return (
    <FilterContextSub.Provider
      value={{
        startDate,
        endDate,
        company,
        appliedStartDate,
        appliedEndDate,
        appliedCompany,
        setStartDate,
        setEndDate,
        setCompany,
        handleFilter,
        handleReset,
        hasActiveFilters,
      }}
    >
      {children}
    </FilterContextSub.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContextSub);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};